// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/avatar/style/index.less
// module id = 1074
// module chunks = 1